/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {Modal} from "../../atoms/bootstrap/Modal";
import Spinner from "../../atoms/effects/Spinner";

export function LoadingModalBody() {
    return <Modal.Body className="text-center"><Spinner/></Modal.Body>;
}



